export default {
  modelValue: {
    required: function (value) {
      const startValue = value.treatmentStart
      const endValue = value.treatmentEnd
      const start = !!(startValue.month && startValue.year)
      const end = !!(endValue.month && endValue.year)

      return start && end
    },
    dateSpan: function (value) {
      const startValue = value.treatmentStart
      const endValue = value.treatmentEnd
      const start = `${startValue.year}${startValue.month?.toString().padStart(2, 0)}`
      const end = `${endValue.year}${endValue.month?.toString().padStart(2, 0)}`

      return start <= end
    },
  },
}
